import {IUser} from "data/types/user";
import {TEAM_PREFIX, ENVIRONMENT} from "data/constants";
import {TeamType} from "data/enums";

export enum ConnextraType {
	HOME = "f2p_blitzpicks_homepage",
	REGISTRATION_START = "f2p_blitzpicks_regstart",
	REGISTRATION_CONFIRM = "f2p_blitzpicks_regconfirm",
	LOGIN = "f2p_blitzpicks_loggedin",
	PICKS_START = "f2p_blitzpicks_pickstart",
	PICKS_CONFIRM = "f2p_blitzpicks_pickconfirm",
	LANDING = "f2p_blitzpicks_landingpage",
	SHARE = "f2p_blitzpicks_shareclick",
}

const CONNEXTRA_URL = `https://zz.connextra.com/dcs/tagController/tag/8ce716f59752/`;

export const createConnextraScriptTag = (type: ConnextraType, user?: IUser) => {
	const elementName = "script";
	const SCRIPT_ID = "connextra-tagging";
	document.getElementById(SCRIPT_ID)?.remove();
	const src = `${CONNEXTRA_URL}${type}`;

	const url = new URL(src);

	url.searchParams.append("Team", TEAM_PREFIX);

	if (user?.id) {
		url.searchParams.append("userID", `${user.id}`);
	}

	const script = document.createElement(elementName);
	script.id = SCRIPT_ID;
	script.src = url.toString();
	script.async = true;
	script.defer = true;

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);
	if (ENVIRONMENT === "uat") {
		console.log(type);
	}

	return script;
};

const placements: Record<TeamType, string> = {
	[TeamType.ALS]: "DDM_F2P_BlitzPicks_MontrealAlouettesSponsorTracker_1x1",
	[TeamType.ARGOS]: "DDM_F2P_BlitzPicks_TorontoArgonautsSponsorTracker_1x1",
	[TeamType.BOMBERS]: "DDM_F2P_BlitzPicks_WinnipegBlueBombersSponsorTracker_1x1",
	[TeamType.ELKS]: "DDM_F2P_BlitzPicks_EdmontonElksSponsorTracker_1x1",
	[TeamType.LIONS]: "DDM_F2P_BlitzPicks_BCLionsSponsorTracker_1x1",
	[TeamType.REDBLACKS]: "DDM_F2P_BlitzPicks_OttawaRedblacksSponsorTracker_1x1",
	[TeamType.RIDERS]: "DDM_F2P_BlitzPicks_SaskatchewanRoughridersSponsorTracker_1x1",
	[TeamType.STAMPS]: "DDM_F2P_BlitzPicks_CalgaryStampedersSponsorTracker_1x1",
	[TeamType.TICATS]: "DDM_F2P_BlitzPicks_HamiltonTigerCatsSponsorTracker_1x1",
};
export const buildTrackLink = (value?: string) => {
	if (!value) {
		return;
	}
	const place = placements[TEAM_PREFIX] || "null";
	const url = encodeURIComponent(value);
	return `https://ssl.connextra.com/CFL/selector/click?client=CFL&placement=${place}&tclk=${url}`;
};

export const buildImpLink = () => {
	const place = placements[TEAM_PREFIX] || "null";
	return `https://ssl.connextra.com/CFL/selector/image?client=CFL&placement=${place}`;
};
